import React, { useRef, useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Loader from './Loader';

const ScrollableRow = ({
    title,
    items,
    itemsPerRow,
    renderItem,
    isLoading = false,
    noItemsMessage,
}) => {
    const containerRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    // Show scroll buttons only if items exceed itemsPerRow
    const showScrollButtons = items?.length > itemsPerRow;

    useEffect(() => {
        const checkScroll = () => {
            if (containerRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
                setCanScrollLeft(scrollLeft > 0);
                setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
            }
        };

        checkScroll();
        const container = containerRef.current;
        container?.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll);
        return () => {
            container?.removeEventListener('scroll', checkScroll);
            window.removeEventListener('resize', checkScroll);
        };
    }, [items]);

    const scroll = (direction) => {
        const scrollAmount = 300; // Adjustable scroll distance
        if (containerRef.current) {
            containerRef.current.scrollBy({
                left: direction * scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div className="scrollable-row">
            {title && <div className="heading-container">
                <h2>{title}</h2>
            </div>}

            {isLoading ? (
                <Loader type="simpleMini" />
            ) : items?.length === 0 ? (
                <p className="no-items">{noItemsMessage}</p>
            ) : (
                <div className="items-wrapper">
                    {showScrollButtons && (
                        <button
                            className="chevron-btn left"
                            onClick={() => scroll(-1)}
                            disabled={!canScrollLeft}
                            aria-label="Scroll left"
                        >
                            <FaChevronLeft />
                        </button>
                    )}
                    <div className="items-container" ref={containerRef}>
                        {items?.map((item, index) => renderItem(item, index))}
                    </div>
                    {showScrollButtons && (
                        <button
                            className="chevron-btn right"
                            onClick={() => scroll(1)}
                            disabled={!canScrollRight}
                            aria-label="Scroll right"
                        >
                            <FaChevronRight />
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default ScrollableRow;